import { createSelector } from 'reselect'

const getState = state => state.playlists

export const getPlaylist = createSelector(
  getState,
  ({ playlists }) => playlists
)

export const getPlaylistsAdmin = createSelector(
  getState,
  ({ adminPlaylists }) => adminPlaylists
)

export const getTotalPlaylistsCountAdmin = createSelector(
  getState,
  ({ totalPlaylistsAdminTab }) => totalPlaylistsAdminTab
)

export const getFoundPlaylists = createSelector(
  getState,
  ({ foundPlaylists }) => foundPlaylists
)

export const getAllPlaylistsSpotifyIds = createSelector(
  getState,
  ({ playlists }) =>
    playlists.map(playlist => {
      const arr = playlist?.playlist_url.split('/')
      return arr[arr.length - 1]
    })
)
